module.exports = __webpack_public_path__ + "static/logo-lai-tkd-141a9de3d92cd1eb148baf220a46470c.png";